module.exports = __webpack_public_path__ + "img/Posada-cabo_0007_hotel1.f8eeb235.jpg";